import {} from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { Well } from 'components';
import { usePermissions } from 'hooks';
import { isEmpty } from 'lodash';
import { ReactNode } from 'react';
import { IMember } from 'types';
import { t } from 'utils/localize';

export interface IEditTimePermissionWellProps {
  className?: string | object;
  members: IMember[];
}

const EditTimePermissionWell = (props: IEditTimePermissionWellProps) => {
  const { className, members } = props;

  const { hasPermissionToManage } = usePermissions();

  function optionallyRenderWell(): ReactNode {
    if (isEmpty(members)) {
      return <></>;
    }
    const canNotMangeMembers = members.filter((member) => !hasPermissionToManage(member, 'manageTimeEntries'));
    if (!isEmpty(canNotMangeMembers)) {
      let message: string = t(
        'You do not have permission to edit one or more of the selected items. These items will not be updated.'
      );
      if (canNotMangeMembers.length === members.length) {
        message = t('You do not have permission to edit the selected items.');
      }
      return (
        <Well className={classes} theme="danger">
          {message}
        </Well>
      );
    }
    return <></>;
  }

  const classes = classNames('edit-time-permission-well', 'mb-4', 'ac-fade-slide-down', className);

  return <>{optionallyRenderWell()}</>;
};

export default EditTimePermissionWell;
